import {IStudioLibraryItem} from './IStudioLibraryItem';

export class StudioTemplate{
  id: number;
  name: string;
  type: any;
  assets:IStudioLibraryItem[];
}



// WEBPACK FOOTER //
// /var/lib/jenkins/workspace/pmclient-uat/src/app/shared/models/studioTemplate.ts